import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";

export default function Mealinfo() {
  const { mealid } = useParams();
  const [info, setInfo] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const getInfo = async () => {
      try {
        setIsLoading(true);
        const get = await fetch(
          `https://www.themealdb.com/api/json/v1/1/lookup.php?i=${mealid}`
        );
        const jsonData = await get.json();
        setInfo(jsonData.meals ? jsonData.meals[0] : null);
      } catch (error) {
        console.error("Error fetching data:", error);
        setInfo(null);
      } finally {
        setIsLoading(false);
      }
    };

    if (mealid) {
      getInfo();
    }
  }, [mealid]);

  return (
    <div>
      {isLoading ? (
        <img
          src="https://upload.wikimedia.org/wikipedia/commons/b/b1/Loading_icon.gif"
          width={250}
          style={{ display: "block", margin: "auto" }}
          alt="Loading..."
        />
      ) : info ? (
        <div className="mealInfo">
          <img src={info.strMealThumb} alt={info.strMeal} />
          <div className="info">
            <h1>Recipe Detail</h1>
            <button>{info.strMeal}</button>
            <h3>Instruction</h3>
            <p>{info.strInstructions}</p>
          </div>
        </div>
      ) : (
        <p>Data Not Found</p>
      )}
    </div>
  );
}
